import { cleApi } from "./client";

const ADMIN_ME_PATH = "auth/me";

export interface AdminMeResponse {
  clerk_user_id: string;
  /** Admin-id'et for aktørspor (kommentarer, audit trail). */
  admin_user_id: string;
  /** Alle id'er en tildeling til denne bruger kan være gemt under. */
  assignment_user_ids: string[];
  email: string | null;
  name: string | null;
  roles: string[];
  policies: string[];
  organization_id: string | null;
}

export const getAdminMe = (): Promise<AdminMeResponse> =>
  cleApi.get<AdminMeResponse>(ADMIN_ME_PATH);
